export default __webpack_public_path__ + "static/media/ThierryMbarushimana.f77e7d6f.png";